/* istanbul ignore file */
import {createSelector} from 'reselect';

export const getSystem = (state) => state.system;

export const getFullLocale = createSelector(
    getSystem,
    (system) => {
        return system.fullLocale;
    }
);

export const getIsMobile = createSelector(
    getSystem,
    (system) => {
        return system.isMobile;
    }
);

export const getLocale = createSelector(
    getSystem,
    (system) => {
        return system.locale;
    }
);

export const getSiteName = createSelector(
    getSystem,
    (system) => {
        return system.siteName;
    }
);

export default {
    getFullLocale,
    getIsMobile,
    getLocale,
    getSystem,
    getSiteName
};


// WEBPACK FOOTER //
// ./src/universal/selectors/system.js